<template>
  <div class="Editcalculatecode">
    <div class="header">
      <a-breadcrumb>
        <a-breadcrumb-item>首页</a-breadcrumb-item>
        <a-breadcrumb-item>
          <a>内容中心</a>
        </a-breadcrumb-item>
        <a-breadcrumb-item>
          <a>算分码管理</a>
        </a-breadcrumb-item>
        <a-breadcrumb-item>编辑算分码</a-breadcrumb-item>
      </a-breadcrumb>
      <div class="detail">
        <div>
          <input placeholder="请输入算分码" v-model="calculatecode" :disabled="type == 'edit'">
          <!-- <a-icon type="edit" @click="edit()" v-if="type == 'edit'"/> -->
        </div>
        <input placeholder="备注" v-model="remark" class='remark'>
      </div>
    </div>
    <a-card class="content">
      <div class="top">
        <h4>算法代码编辑</h4>
        <span>
          <a-button type="primary" @click="saveCalculateCode()" :disavled="saveLoading">保存</a-button>
          <a-button style="margin-left: 8px" @click="testCalculateCode()">测试算法</a-button>
        </span>
      </div>
      <div class="codeBox">
        <div class="in-coder-panel">
          <textarea ref="textarea"></textarea>
          <a-select class="code-mode-select" v-model="mode" @change="changeMode">
            <a-select-option
              v-for="mode in modes"
              :key="mode.value"
              :label="mode.label"
              :value="mode.value"
            >{{mode.label}}</a-select-option>
          </a-select>
        </div>
      </div>
    </a-card>
    <a-modal v-model="testModal" title="算法校验" @ok="handleOk" ok-text="开始计算" class="testModal">
      <div class="modalItem">
        <label>计算数据:</label>
        <a-textarea placeholder="输入计算数据"/>
      </div>
      <div class="modalItem">
        <label>计算结果:</label>
        <span>95.26</span>
      </div>
    </a-modal>
  </div>
</template>

<script>
// 引入全局实例
import _CodeMirror from "codemirror";

// 核心样式
import "codemirror/lib/codemirror.css";
// 引入主题后还需要在 options 中指定主题才会生效
import "codemirror/theme/cobalt.css";

// 需要引入具体的语法高亮库才会有对应的语法高亮效果
// codemirror 官方其实支持通过 /addon/mode/loadmode.js 和 /mode/meta.js 来实现动态加载对应语法高亮库
// 但 vue 貌似没有无法在实例初始化后再动态加载对应 JS ，所以此处才把对应的 JS 提前引入
import "codemirror/mode/javascript/javascript.js";
import "codemirror/mode/css/css.js";
import "codemirror/mode/xml/xml.js";
import "codemirror/mode/clike/clike.js";
import "codemirror/mode/markdown/markdown.js";
import "codemirror/mode/python/python.js";
import "codemirror/mode/r/r.js";
import "codemirror/mode/shell/shell.js";
import "codemirror/mode/sql/sql.js";
import "codemirror/mode/swift/swift.js";
import "codemirror/mode/vue/vue.js";

// 尝试获取全局实例
const CodeMirror = window.CodeMirror || _CodeMirror;

export default {
  name: "Editcalculatecode",
  props: {
    // 外部传入的内容，用于实现双向绑定
    value: String,
    // 外部传入的语法类型
    language: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      type: "add",
      calculateCodeItem:{},
      // 算分码
      calculatecode: "",
      // 备注
      remark:'',
      // 输入代码内容
      code: "",
      // 默认的语法类型
      mode: "javascript",
      // 编辑器实例
      coder: null,
      // 默认配置
      options: {
        // 缩进格式
        tabSize: 2,
        // 主题，对应主题库 JS 需要提前引入
        theme: "cobalt",
        // 显示行号
        lineNumbers: true,
        line: true
      },
      // 支持切换的语法高亮类型，对应 JS 已经提前引入
      // 使用的是 MIME-TYPE ，不过作为前缀的 text/ 在后面指定时写死了
      modes: [
        {
          value: "css",
          label: "CSS"
        },
        {
          value: "javascript",
          label: "Javascript"
        },
        {
          value: "html",
          label: "XML/HTML"
        },
        {
          value: "x-java",
          label: "Java"
        },
        {
          value: "x-objectivec",
          label: "Objective-C"
        },
        {
          value: "x-python",
          label: "Python"
        },
        {
          value: "x-rsrc",
          label: "R"
        },
        {
          value: "x-sh",
          label: "Shell"
        },
        {
          value: "x-sql",
          label: "SQL"
        },
        {
          value: "x-swift",
          label: "Swift"
        },
        {
          value: "x-vue",
          label: "Vue"
        },
        {
          value: "markdown",
          label: "Markdown"
        }
      ],
      saveLoading:false,
      testModal:false,
    };
  },
  created() {
    this.type = this.$route.query.type;
    if(localStorage.getItem('calculateCodeItem') && this.$route.query.type == 'edit'){
      this.calculateCodeItem = JSON.parse(localStorage.getItem('calculateCodeItem'))
      this.calculatecode = this.calculateCodeItem.code;
      this.remark = this.calculateCodeItem.remark;
      this.code = this.calculateCodeItem.algorithm || ''
    }
    
  },
  mounted() {
    // 初始化
    this._initialize();
    // document.getElementsByClassName('page-header').style.display = 'none'
    document.getElementsByClassName('page-header')[0].style = 'display:none !important;'
  },
  destroyed(){
    document.getElementsByClassName('page-header')[0].style = 'display:block !important;'
  },
  methods: {
    edit() {
      this.type = "add";
    },
    // 初始化
    _initialize() {
      // 初始化编辑器实例，传入需要被实例化的文本域对象和默认配置
      this.coder = CodeMirror.fromTextArea(this.$refs.textarea, this.options);
      // 编辑器赋值
      this.coder.setValue(this.value || this.code);
      // 支持双向绑定
      this.coder.on("change", coder => {
        this.code = coder.getValue();
        if (this.$emit) {
          this.$emit("input", this.code);
        }
      });
      // 尝试从父容器获取语法类型
      if (this.language) {
        // 获取具体的语法类型对象
        let modeObj = this._getLanguage(this.language);
        // 判断父容器传入的语法是否被支持
        if (modeObj) {
          this.mode = modeObj.label;
        }
      }
    },
    // 获取当前语法类型
    _getLanguage(language) {
      // 在支持的语法类型列表中寻找传入的语法类型
      return this.modes.find(mode => {
        // 所有的值都忽略大小写，方便比较
        let currentLanguage = language.toLowerCase();
        let currentLabel = mode.label.toLowerCase();
        let currentValue = mode.value.toLowerCase();

        // 由于真实值可能不规范，例如 java 的真实值是 x-java ，所以讲 value 和 label 同时和传入语法进行比较
        return (
          currentLabel === currentLanguage || currentValue === currentLanguage
        );
      });
    },
    // 更改模式
    changeMode(val) {
      // 修改编辑器的语法配置
      this.coder.setOption("mode", `text/${val}`);
      // 获取修改后的语法
      let label = this._getLanguage(val).label.toLowerCase();
      // 允许父容器通过以下函数监听当前的语法值
      this.$emit("language-change", label);
    },
    // 测试
    testCalculateCode(){
      this.testModal = true
    },
    handleOk(){
      console.log(this.code)
      if(!this.code){
        this.$message.destroy()
        this.$message.error('算法不能为空');
        return
      }
      this.testModal = false
    },
    // 保存
    saveCalculateCode(){
      if(!this.code){
        this.$message.destroy()
        this.$message.error('算法不能为空');
        return
      }
      this.saveLoading = true
      let params = {
        code:this.calculatecode,
        remark:this.remark,
        algorithm:this.code,
      }
      if(this.$route.query.type == 'edit'){
        params.oldCode = this.calculateCodeItem.code
        this.editCalculateCode(params)
      }else{
        this.addCalculateCode(params)
      }
    },
    addCalculateCode(params){
      this.$http.addAlgorithmCode(params)
      .then(res => {
        this.saveLoading = false
          this.$message.success('添加成功');
       
      });
    },
    editCalculateCode(params){
      this.$http.editAlgorithmCode(params)
      .then(res => {
        this.saveLoading = false
          this.$message.success('修改成功');
        
      });
    }
  }
};
</script>

<style lang="less" scoped>
.Editcalculatecode {
  margin-top: -24px;
  .header {
    // height: 119px;
    background: #fff;
    padding: 16px 24px;
    margin: 0 -24px 0;
    .ant-breadcrumb a:hover {
      color: rgba(0, 0, 0, 0.45);
    }
    .ant-breadcrumb {
      margin-bottom: 20px;
    }
    .detail {
      input {
        border: none;
        outline: none;
        font-size: 20px;
        color: rgba(0, 0, 0, 0.85);
        font-weight: 600;
      }
      input::placeholder {
        font-size: 16px;
      }
      input:disabled {
        background-color: #fff;
      }
      .remark {
        font-size: 16px;
        color: rgba(0, 0, 0, 0.45);
        margin-left: 30px;
        // padding: 15px 0;
        margin-top: 15px;
      }
    }
  }
  .content {
    margin-top: 24px;
    .top {
      display: flex;
      justify-content: space-between;
      align-items: center;
      h4 {
        font-size: 16px;
        font-weight: 600;
        color: rgba(0, 0, 0, 0.85);
      }
    }
    .codeBox {
      margin-top: 15px;
      height: 400px;
      border: 1px solid #ccc;
    }
  }
  
  
}
.testModal{
  .modalItem{
    display: flex;
    margin-bottom:10px;
    label{
      width: 70px;
    }
    .ant-input{
      min-height:200px;
      flex:1;
    }
  }
}
</style>
<style lang="stylus" rel="stylesheet/stylus">
.in-coder-panel {
  flex-grow: 1;
  display: flex;
  position: relative;

  .CodeMirror {
    flex-grow: 1;
    z-index: 1;
    height:400px;
    .CodeMirror-code {
      line-height: 19px;
    }
  }

  .code-mode-select {
    position: absolute;
    z-index: 2;
    right: 17px;
    top: 10px;
    min-width: 130px;
  }
}
</style>
